import { ChangeEvent, Dispatch } from "react";
import { Types } from "../../context/CollaboratorContext/CollaboratorContext";
import {
  validateContacts,
  validateDatosPago,
  validateExpedient,
  validateSection,
  validateInformationDatosPersonales,
  validateSection2,
} from "./Fields";

export const updateData = async (
  e: ChangeEvent<{ name: string; value: unknown }>,
  state: any,
  dispatch: Dispatch<any>,
  index: number
): Promise<void> => {
  if (e.target.value !== "")
    state.collaborator[e.target.name] = e.target.value;
  else state.collaborator[e.target.name] = undefined;
    updateCollaborator(state.collaborator, dispatch);
};

export const updateFile = async (
  files: any,
  state: any,
  dispatch: Dispatch<any>
): Promise<void> => {
  state.collaborator["Archivos"] = {};
  await updateCollaborator(state.collaborator, dispatch);
  state.collaborator["Archivos"]["CartaOferta"] = files[0];
  await updateCollaborator(state.collaborator, dispatch); 
  await ValidateSection(state, 0, dispatch);
};

const updateCollaborator = (
  collaborator: any,
  dispatch: Dispatch<any>
): void => {
  dispatch({
    type: Types.UPDATE_COLLABORATOR,
    payload: {
      collaborator,
      loading:false
    },
  });
};

export const ValidateSection = async (
  state: any,
  index: number,
  dispatch: Dispatch<any>
): Promise<void> => {
  let tab = "1"; // Informacion de Alta
  if (index === 1) tab = "2"; // Datos Personales
  if (index === 2 || index === 3 || index === 4) tab = "3"; // Contactos
  if (index === 5) tab = "4"; // Banco
  if (index === 6) tab = "5"; // Expediente
  await fetchingData(state.collaborator, dispatch, tab);
};

const fetchingData = async (
  user: any,
  dispatch: Dispatch<any>,
  tab: string,
  temp: Array<number> = [0, 0, 0, 0, 0]
) => {
  let steps: Array<any> = [];
  let sections: number = 3;
  let tempSections: Array<any> = [];
  switch (tab) {
    case "1":
      steps = [
        { start: 0, end: 4 },
        { start: 4, end: 11 },
        { start: 11, end: 20 },
      ];
      tempSections = await fetchindDataSections(sections, user, steps, 0);
      break;
    case "2":
      steps = [
        { start: 0, end: 7 },
        { start: 7, end: 12 },
        { start: 12, end: 16 },
      ];
      tempSections = await fetchindDataSections(sections, user, steps, 1);
      break;
    case "3":
      steps = [
        { start: 0, end: 10 },
        { start: 10, end: 15 },
        { start: 15, end: 19 },
      ];
      tempSections = await fetchindDataSections(
        sections,
        user.Contactos?.Beneficiario || {},
        steps,
        2
      ); // Seccion Contacto de Beneficiario
      tempSections[1] = (
        await fetchindDataSections(
          sections,
          user.Contactos?.ContactoEmergencia || {},
          steps,
          2
        )
      )[1]; // Seccion Contacto de Emergencia
      tempSections[2] = (
        await fetchindDataSections(
          sections,
          user.Contactos?.Enfermedades || {},
          steps,
          2
        )
      )[2]; // Seccion Contacto de Enfermedades
      break;
    case "4":
      steps = [{ start: 0, end: 4 }];
      sections = 1;
      tempSections = await fetchindDataSections2(
        sections,
        user.DatosPago || {},
        steps,
        3,
        user.Archivos || {}
      );
      break;
    case "5":
      steps = [
        { start: 0, end: 8 },
        { start: 10, end: 12 },
        { start: 8, end: 10 },
      ];
      tempSections = await fetchindDataSections(
        sections,
        user.Archivos || {},
        steps,
        4
      );
      break;
  }

  // Informacion de Alta
  temp[1] = await validateInformationDatosPersonales(
    user?.DatosPersonales || {},
    16
  );
  let contacts = await validateContacts(
    user?.Contactos?.Beneficiario || {},
    15
  ); // Contactos Beneficiario
  contacts += await validateContacts(
    user?.Contactos?.ContactoEmergencia || {},
    15
  ); // Contactos Contacto de Emergencia
  temp[2] = contacts;

  temp[3] = await validateDatosPago(
    user?.DatosPago || {},
    4,
    user?.Archivos || {}
  ); // Datos de pago

  temp[4] = await validateExpedient(user?.Archivos || {}, 9); // Expediente

  dispatch({
    type: Types.SET_COLLABORATOR,
    payload: {
      progress: [...temp],
      sections: [...tempSections],
    },
  });
  return temp;
};

const fetchindDataSections = async (
  sections: number,
  user: any,
  steps: Array<any>,
  index: number
) => {
  let tempSections = [0, 0, 0, 0];
  
  for (let i = 0; i < sections; i++) {
    let section = await validateSection(
      user,
      steps[i].start,
      steps[i].end,
      index
    );

    tempSections[i] = section;
  }
  return tempSections;
};

const fetchindDataSections2 = async (
  sections: number,
  user: any,
  steps: Array<any>,
  index: number,
  archivos: any
) => {
  let tempSections = [0, 0, 0, 0];
  for (let i = 0; i < sections; i++) {
    let section = await validateSection2(
      user,
      steps[i].start,
      steps[i].end,
      index,
      archivos
    );
    tempSections[i] = section;
  }
  return tempSections;
};

const fetchingAllData = async (
  user: any,
  dispatch: Dispatch<any>,
  tab: string
) => {
  await fetchingData(user, dispatch, tab);
};

const handleSetActiveStep = (
  activeStep: any,
  dispatch: Dispatch<any>
): void => {
  dispatch({
    type: Types.SET_ACTIVESTEP,
    payload: {
      activeStep,
    },
  });
};

export { fetchingData, updateCollaborator, fetchingAllData, handleSetActiveStep};
